import { render, staticRenderFns } from "./lsdocs1.vue?vue&type=template&id=91a3ba54&scoped=true"
import script from "./lsdocs1.vue?vue&type=script&lang=js"
export * from "./lsdocs1.vue?vue&type=script&lang=js"
import style0 from "./lsdocs1.vue?vue&type=style&index=0&id=91a3ba54&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a3ba54",
  null
  
)

export default component.exports